<template>
  <div class="component-container">
    <loading-state v-if="!loading" variant="indicators" />
    <div v-else class="indicators-container">
      <span class="indicators-title">Evolução dos indicadores</span>
      <v-select v-model="selectedValue" class="header-input mt-10" :items="selectItems" outlined dense></v-select>
      <div class="graph">
        <div class="header-titles">
          <div class="header-spacer"></div>
          <div class="selected-periods">
            <div class="reference-period">
              <span>Período referência</span>
              <div class="dates-text">
                <h1>{{ formattedReferenceDates ? formattedReferenceDates.initialDate : '-' }}</h1>
                <h1 class="dash">—</h1>
                <h1>{{ formattedReferenceDates ? formattedReferenceDates.finalDate : '-' }}</h1>
              </div>
            </div>
            <div class="current-period">
              <span>Período analisado</span>
              <div class="dates-text">
                <h1>{{ formattedCurrentDates.initialDate }}</h1>
                <h1 class="dash">—</h1>
                <h1>{{ formattedCurrentDates.finalDate }}</h1>
              </div>
            </div>
          </div>
          <div class="variation-text">
            <span>Variação</span>
          </div>
        </div>
        <div v-for="indicator in graphItems" :key="indicator.title" class="indicator-line">
          <div class="client-title">
            <span>{{ indicator.title }}</span>
          </div>
          <div class="indicators-evolution">
            <div class="reference-indicator">
              <span v-if="indicator.referenceValue !== null">
                {{ getIndicatorValue(indicator.referenceValue, notLocaleKeys.includes(selectedValue) ? 0 : 2, indicator.key) }}
              </span>
              <span v-else>-</span>
              <div class="indicator-bar" :style="{ width: getBarWidth(indicator.referenceValue, indicator.key) }"></div>
            </div>
            <div class="current-indicator">
              <div class="indicator-bar" :style="{ width: getBarWidth(indicator.currentValue) }"></div>
              <span v-if="indicator.currentValue !== null">
                {{ getIndicatorValue(indicator.currentValue, notLocaleKeys.includes(selectedValue) ? 0 : 2, indicator.key) }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
          <div class="variation-percentage">
            <mf-stonks variant="percentage" :percentage="getIndicatorVariation(indicator)" :show-only-icon="selectedValue === 'recency'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MfStonks from '../../../../../maria/produtos-impulsionadores/views/components/Step1/MfStonks.vue'
import { localeString } from '@/config/helpers.js'
import { rfvAnalysis } from '../../../mixins/analise-rfv'
import { rfvIndicatorsEvolution } from '../../../mixins/rfv-indicators-evolution'
import LoadingState from './LoadingState.vue'
export default {
  name: 'IndicatorsEvolution',
  components: {
    MfStonks,
    LoadingState,
  },
  mixins: [rfvAnalysis, rfvIndicatorsEvolution],
  props: {
    loadingReferencePeriod: {
      type: Boolean,
      default: true,
    },
    loadingCurrentPeriod: {
      type: Boolean,
      default: true,
    },
    formattedReferenceDates: {
      type: Object,
    },
    formattedCurrentDates: {
      type: Object,
    },
  },
  data: () => ({
    total: null,
    selectedValue: 'clients',
    selectItems: [
      {
        value: 'clients',
        text: 'Consumidores',
      },
      {
        value: 'revenue',
        text: 'Faturamento',
      },
      {
        value: 'percentageRevenue',
        text: '% do faturamento',
      },
      {
        value: 'monthlyAverageRevenuePerClient',
        text: 'Gasto médio mensal',
      },
      {
        value: 'averageTicket',
        text: 'Ticket médio',
      },
      {
        value: 'tickets',
        text: 'Cupons do período',
      },
      {
        value: 'percentageTickets',
        text: '% dos cupons',
      },
      {
        value: 'recency',
        text: 'Recência',
      },
      {
        value: 'frequency',
        text: 'Frequência',
      },
    ],
  }),
  computed: {
    loading() {
      return !this.loadingCurrentPeriod && !this.loadingReferencePeriod
    },
    setHifen() {
      return ['frequency', 'recency'].includes(this.selectedValue)
    },
    getMaxIndicatorValue() {
      let values = []
      this.graphItems.map((item) => values.push(item.referenceValue, item.currentValue))
      return Math.max(...values)
    },
    graphItems() {
      if (this.currentClientsMetrics || this.referenceClientsMetrics) {
        return [
          {
            title: 'Campeões',
            key: 'champions',
            referenceValue: this.getClientReferenceMetric('champions'),
            currentValue: this.getClientCurrentMetric('champions'),
            variation: this.getVariation(this.getClientReferenceMetric('champions'), this.getClientCurrentMetric('champions')),
          },
          {
            title: 'Clientes leais',
            key: 'loyals',
            referenceValue: this.getClientReferenceMetric('loyals'),
            currentValue: this.getClientCurrentMetric('loyals'),
            variation: this.getVariation(this.getClientReferenceMetric('loyals'), this.getClientCurrentMetric('loyals')),
          },
          {
            title: 'Promissores',
            key: 'promising',
            referenceValue: this.getClientReferenceMetric('promising'),
            currentValue: this.getClientCurrentMetric('promising'),
            variation: this.getVariation(this.getClientReferenceMetric('promising'), this.getClientCurrentMetric('promising')),
          },
          {
            title: 'Em risco',
            key: 'atRisk',
            referenceValue: this.getClientReferenceMetric('atRisk'),
            currentValue: this.getClientCurrentMetric('atRisk'),
            variation: this.getVariation(this.getClientReferenceMetric('atRisk'), this.getClientCurrentMetric('atRisk')),
          },
          {
            title: 'Baixo valor',
            key: 'lowValue',
            referenceValue: this.getClientReferenceMetric('lowValue'),
            currentValue: this.getClientCurrentMetric('lowValue'),
            variation: this.getVariation(this.getClientReferenceMetric('lowValue'), this.getClientCurrentMetric('lowValue')),
          },
          {
            title: 'Perdidos',
            key: 'losses',
            referenceValue: this.getClientReferenceMetric('losses'),
            currentValue: this.getClientCurrentMetric('losses'),
            variation: this.getVariation(this.getClientReferenceMetric('losses'), this.getClientCurrentMetric('losses')),
          },
        ]
      } else return []
    },
  },
  methods: {
    localeString,
    getBarWidth(value) {
      return localeString((value * 100) / this.getMaxIndicatorValue, 0) + '%'
    },
  },
}
</script>

<style lang="scss" scoped>
.component-container {
  width: 100%;
  .indicators-container {
    width: 100%;
    .header-input {
      margin-bottom: -66px;
    }
    .indicators-title {
      color: $cinza-d10;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.333px;
    }
    .graph {
      max-width: 80%;
      margin: 0 auto;
      .header-titles {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .header-spacer {
          width: 110px;
          height: 100%;
        }
        .variation-text {
          width: 10%;
          display: flex;
          justify-content: flex-start;
          padding-left: 5px;
          span {
            color: $cinza-d10;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
          }
        }
        .selected-periods {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          gap: 48px;
          width: 85%;
          .reference-period {
            width: 50%;
            display: flex;
            flex-direction: column;
            text-align: end;
            span {
              color: $cinza-l20;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
            }
            .dates-text {
              gap: 8px;
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              h1 {
                color: $cinza-d10;
                font-size: 18px;
                font-weight: 400;
                line-height: 120%; /* 21.6px */
              }
              .dash {
                color: $cinza-l20;
              }
            }
          }
          .current-period {
            width: 50%;
            display: flex;
            flex-direction: column;
            span {
              color: $marca-0-l40;
              font-size: 14px;
              font-weight: 400;
              line-height: 20px; /* 142.857% */
            }
            .dates-text {
              gap: 8px;
              display: flex;
              flex-direction: row;
              h1 {
                color: $marca-0-l10;
                font-size: 18px;
                font-weight: 400;
                line-height: 120%; /* 21.6px */
              }
              .dash {
                color: $marca-0-l40;
              }
            }
          }
        }
      }
      .indicator-line {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px $cinza-l80;
        min-height: 52px;
        .client-title {
          width: 110px;
          span {
            color: $cinza-d20;
            font-size: 16px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0.4px;
          }
        }
        .variation-percentage {
          width: 10%;
          display: flex;
          justify-content: flex-start;
        }
        .indicators-evolution {
          display: flex;
          flex-direction: row;
          width: 75%;
          gap: 20px;
          .reference-indicator {
            width: 50%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            gap: 6px;
            span {
              color: $cinza-l20;
              font-size: 16px;
              line-height: 20px; /* 125% */
              letter-spacing: 0.4px;
              width: 65%;
              text-align: end;
            }
            .indicator-bar {
              border-radius: 8px 0px 0px 8px;
              background-color: $cinza-l40;
              height: 16px;
            }
          }
          .current-indicator {
            width: 50%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 6px;
            span {
              color: $marca-0-l40;
              font-size: 16px;
              line-height: 20px; /* 125% */
              letter-spacing: 0.4px;
              width: 65%;
              text-align: start;
            }
            .indicator-bar {
              background-color: $marca-0-l40;
              border-radius: 0px 8px 8px 0px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
.v-input {
  max-width: 175px !important;
}
::v-deep .v-select {
  width: 175px;
}
::v-deep fieldset {
  border-color: $marca-0-l10;
}
::v-deep .v-select__selection {
  font-size: 14px;
  color: $marca-0-l10 !important;
}

::v-deep input {
  color: $marca-0-l10 !important;
}

::v-deep .mdi-menu-down,
::v-deep i {
  color: $marca-0-l10;
}
</style>
